// Product agnostic
export enum TrackType {
	BRIEFING = 'BRIEFING',
	NARRATION = 'NARRATION',
}
